module.exports = __webpack_public_path__ + "img/search.aad073a1.png";